/**
 * New console — a settings row, and the controls that sit in one.
 *
 * The appearance panel and the Settings screen were each drawing their own copy of
 * these. They are one vocabulary — a title, a line saying what the setting does, and
 * the control on the right — so they live in one place and read the same everywhere.
 */
import { HoverTip } from './Primitives';

export const SetRow = ({ title, detail, children }) => (
  <div className="nt-set-row">
    <div>
      <div className="t">{title}</div>
      <div className="d">{detail}</div>
    </div>
    <div style={{ flex: 'none' }}>{children}</div>
  </div>
);

export const Switch = ({ on, onChange, label }) => (
  <label className="nt-switch">
    <input
      type="checkbox"
      checked={!!on}
      onChange={(e) => onChange(e.target.checked)}
      aria-label={label}
    />
    <span />
  </label>
);

/** A row of choices where exactly one is on — theme, density, text size. */
export const Seg = ({ value, onChange, options, label }) => (
  <div className="nt-seg" role="group" aria-label={label}>
    {options.map((o) => (
      <HoverTip key={String(o.value)} text={o.hint}>
        <button
          type="button"
          aria-pressed={String(value) === String(o.value)}
          className={String(value) === String(o.value) ? 'on' : ''}
          onClick={() => onChange(o.value)}
        >
          {o.icon || null}{o.label}
        </button>
      </HoverTip>
    ))}
  </div>
);

export const Group = ({ title, children }) => (
  <>
    <div className="nt-eyebrow" style={{ margin: '14px 0 2px' }}>{title}</div>
    <div className="nt-stack" style={{ gap: 2 }}>{children}</div>
  </>
);
